export enum TransportTypes {
	DrivesOwnVehicle = "Drives Own Vehicle",
	PublicTransport = "Use Public Transport",
	VehicleOther = "Access to Another Vehicle",
	Bicycle = "Bicycle",
	NoAccess = "No Access",
	Other = "Other",
}
